import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import IconEmpty from '../../../assets/Images/icons/empty';
import { ROUTER } from '../../../constants/router';
import UserService from '../../../services/UserService';
import usePermission from '../../../hooks/usePermission';

export default function Tab1({ detail }) {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const lang = i18n.language;
    let { riskId } = useParams();
    const [raDetail, setRaDetail] = useState();
    const role = UserService.role().toLowerCase();
    const admin = ['admin', 'auditor', 'super admin'].includes(role);
    const { isAuditor } = usePermission();

    useEffect(() => {
        if (detail?.riskFactor) {
            setRaDetail(detail.riskFactor);
        }
    }, [detail]);

    return (
        <div className="p-4">
            <div className="mb-4" style={{ borderBottom: '3px solid #F4F6FC' }}>
                <div className="flex justify-between">
                    <div className="flex space-x-2 items-center pb-2">
                        <div className="text-2xl font-bold pb-1">
                            {t('RA.RiskFactor')}
                        </div>
                        <Tooltip
                            overlayStyle={{
                                minWidth: '18%',
                            }}
                            placement="rightTop"
                            title={t('Tooltip.RiskFactor')}
                        >
                            <a className="bg-[#F3F6F9] h-8 w-8 flex items-center justify-center rounded-lg text-purple text-sm">
                                <ExclamationCircleOutlined />
                            </a>
                        </Tooltip>
                    </div>
                    <div>
                        <Button
                            disabled={isAuditor}
                            hidden={!admin}
                            type="primary"
                            style={{ padding: '0px 30px' }}
                            onClick={() => {
                                navigate(
                                    `${ROUTER.RISK_MANAGEMENT.RA}/${riskId}?tab=1`
                                );
                            }}
                            size="large"
                            ghost
                        >
                            {t('common.Edit')}
                        </Button>
                    </div>
                </div>

                <div className="pb-6 flex items-center">
                    <div className="font-bold">{t('Last Update')} : </div>
                    <span>&nbsp;&nbsp;</span>
                    <div>{detail?.riskFactorUpdateDate || '-'}</div>
                </div>
            </div>
            {raDetail?.item.length || raDetail?.itemAddOn.length > 0 ? (
                <>
                    {raDetail?.item?.map((item, i) => (
                        <div
                            key={i}
                            className="col-span-2 p-4 mb-4 box-content"
                        >
                            <div className="text-lg font-bold text-purple pb-2">
                                {lang === 'en'
                                    ? item.riskNameEn
                                        ? item.riskNameEn
                                        : '-'
                                    : item.riskNameTh
                                    ? item.riskNameTh
                                    : '-'}
                            </div>
                            <p>
                                {lang === 'en'
                                    ? item.riskDetailEn
                                        ? item.riskDetailEn
                                        : '-'
                                    : item.riskDetailTh
                                    ? item.riskDetailTh
                                    : '-'}
                            </p>

                            {/* subRisk */}
                            {item?.subRisk?.length > 0 && (
                                <>
                                    <div className="font-bold pb-2">
                                        {t('RA.MainRiskFactors')}
                                    </div>
                                    {item.subRisk.map((itemSubRisk, i) => (
                                        <>
                                            <div className="flex space-x-2 items-center pb-2">
                                                <div key={i}>
                                                    {lang === 'en'
                                                        ? itemSubRisk.subRiskNameEn
                                                            ? itemSubRisk.subRiskNameEn
                                                            : '-'
                                                        : itemSubRisk.subRiskNameTh
                                                        ? itemSubRisk.subRiskNameTh
                                                        : '-'}
                                                </div>
                                                {itemSubRisk.subRiskDetailEn ? (
                                                    <Tooltip
                                                        overlayStyle={{
                                                            minWidth: '18%',
                                                        }}
                                                        placement="rightTop"
                                                        title={
                                                            lang === 'en'
                                                                ? itemSubRisk.subRiskDetailEn
                                                                : itemSubRisk.subRiskDetailTh
                                                        }
                                                    >
                                                        <span className="text-purple">
                                                            <ExclamationCircleOutlined />
                                                        </span>
                                                    </Tooltip>
                                                ) : (
                                                    <></>
                                                )}
                                            </div>
                                            {/* riskItem */}
                                            {itemSubRisk?.riskItem?.length >
                                                0 ||
                                            itemSubRisk?.riskItemAddOn?.length >
                                                0 ? (
                                                <div
                                                    className="p-4 mb-2 bg-[#EEE5FF]"
                                                    style={{
                                                        borderRadius: '6px',
                                                    }}
                                                >
                                                    <div className="font-bold pb-2">
                                                        {t(
                                                            'RA.MinorRiskFactors'
                                                        )}
                                                    </div>
                                                    {/* riskItem */}
                                                    {itemSubRisk?.riskItem?.map(
                                                        (itemRiskItem, i) => (
                                                            <div className="flex space-x-2 items-center pb-2">
                                                                <div key={i}>
                                                                    {lang ===
                                                                    'en'
                                                                        ? itemRiskItem.nameEn
                                                                            ? itemRiskItem.nameEn
                                                                            : '-'
                                                                        : itemRiskItem.nameTh
                                                                        ? itemRiskItem.nameTh
                                                                        : '-'}
                                                                </div>
                                                                {itemRiskItem.descriptionEn ? (
                                                                    <Tooltip
                                                                        overlayStyle={{
                                                                            minWidth:
                                                                                '18%',
                                                                        }}
                                                                        placement="rightTop"
                                                                        title={
                                                                            lang ===
                                                                            'en'
                                                                                ? itemRiskItem.descriptionEn
                                                                                    ? itemRiskItem.descriptionEn
                                                                                    : '-'
                                                                                : itemRiskItem.descriptionTh
                                                                                ? itemRiskItem.descriptionTh
                                                                                : '-'
                                                                        }
                                                                    >
                                                                        <span className="text-purple">
                                                                            <ExclamationCircleOutlined />
                                                                        </span>
                                                                    </Tooltip>
                                                                ) : (
                                                                    <></>
                                                                )}
                                                            </div>
                                                        )
                                                    )}

                                                    {/* riskItemAddOn */}
                                                    {itemSubRisk?.riskItemAddOn
                                                        ?.length > 0 && (
                                                        <>
                                                            {itemSubRisk.riskItemAddOn.map(
                                                                (
                                                                    itemRiskItemAddOn,
                                                                    i
                                                                ) => (
                                                                    <div className="flex space-x-2 items-center pb-2">
                                                                        <div
                                                                            key={
                                                                                i
                                                                            }
                                                                        >
                                                                            {itemRiskItemAddOn.name
                                                                                ? itemRiskItemAddOn.name
                                                                                : '-'}
                                                                        </div>
                                                                    </div>
                                                                )
                                                            )}
                                                        </>
                                                    )}
                                                </div>
                                            ) : (
                                                ''
                                            )}
                                        </>
                                    ))}
                                </>
                            )}

                            {/* subRiskAddOn */}
                            {item?.subRiskAddOn?.length > 0 && (
                                <>
                                    {item.subRiskAddOn.map((itemSubRisk, i) => (
                                        <>
                                            <div className="flex space-x-2 items-center pb-2">
                                                <div key={i}>
                                                    {itemSubRisk.name
                                                        ? itemSubRisk.name
                                                        : '-'}
                                                </div>
                                            </div>
                                            {/* riskItem */}

                                            {itemSubRisk.riskItem.length > 0 ||
                                            itemSubRisk.riskItemAddOn.length >
                                                0 ? (
                                                <div
                                                    className="p-4 mb-2 bg-[#EEE5FF]"
                                                    style={{
                                                        borderRadius: '6px',
                                                    }}
                                                >
                                                    <div className="font-bold pb-2">
                                                        {t(
                                                            'RA.MinorRiskFactors'
                                                        )}
                                                    </div>
                                                    {/* riskItem */}
                                                    {itemSubRisk.riskItem.map(
                                                        (itemRiskItem, i) => (
                                                            <div className="flex space-x-2 items-center pb-2">
                                                                <div key={i}>
                                                                    {itemRiskItem.name
                                                                        ? itemRiskItem.name
                                                                        : '-'}
                                                                </div>
                                                            </div>
                                                        )
                                                    )}

                                                    {/* riskItemAddOn */}
                                                    {itemSubRisk.riskItemAddOn
                                                        .length > 0 && (
                                                        <>
                                                            {itemSubRisk.riskItemAddOn.map(
                                                                (
                                                                    itemRiskItemAddOn,
                                                                    i
                                                                ) => (
                                                                    <div className="flex space-x-2 items-center pb-2">
                                                                        <div
                                                                            key={
                                                                                i
                                                                            }
                                                                        >
                                                                            {itemRiskItemAddOn.name
                                                                                ? itemRiskItemAddOn.name
                                                                                : '-'}
                                                                        </div>
                                                                    </div>
                                                                )
                                                            )}
                                                        </>
                                                    )}
                                                </div>
                                            ) : (
                                                ''
                                            )}
                                        </>
                                    ))}
                                </>
                            )}
                        </div>
                    ))}

                    {raDetail?.itemAddOn?.map((item, i) => (
                        <div
                            key={i}
                            className="col-span-2 p-4 mb-4 box-content"
                        >
                            <div className="text-lg font-bold text-purple pb-2">
                                {item.riskName ? item.riskName : '-'}
                            </div>
                            <p>{item.riskDetail ? item.riskDetail : '-'}</p>

                            {/* subRisk */}
                            {item.subRiskAddOn.length > 0 && (
                                <>
                                    <div className="font-bold pb-2">
                                        {t('RA.MainRiskFactors')}
                                    </div>
                                    {item.subRiskAddOn.map((itemSubRisk, i) => (
                                        <>
                                            <div className="flex space-x-2 items-center pb-2">
                                                <div key={i}>
                                                    {itemSubRisk.name
                                                        ? itemSubRisk.name
                                                        : '-'}
                                                </div>
                                            </div>
                                            {/* riskItem */}
                                            {itemSubRisk.riskItemAddOn.length >
                                            0 ? (
                                                <div
                                                    className="p-4 mb-2 bg-[#EEE5FF]"
                                                    style={{
                                                        borderRadius: '6px',
                                                    }}
                                                >
                                                    <div className="font-bold pb-2">
                                                        {t(
                                                            'RA.MinorRiskFactors'
                                                        )}
                                                    </div>
                                                    {/* riskItem */}
                                                    {itemSubRisk.riskItemAddOn.map(
                                                        (itemRiskItem, i) => (
                                                            <div className="flex space-x-2 items-center pb-2">
                                                                <div key={i}>
                                                                    {itemRiskItem.name
                                                                        ? itemRiskItem.name
                                                                        : '-'}
                                                                </div>
                                                            </div>
                                                        )
                                                    )}
                                                </div>
                                            ) : (
                                                ''
                                            )}
                                        </>
                                    ))}
                                </>
                            )}
                        </div>
                    ))}
                </>
            ) : (
                <div className="h-[40vh] flex justify-center items-center">
                    <IconEmpty />
                </div>
            )}
        </div>
    );
}
